import { Component, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "department-person-form",
  templateUrl: "./department-person-form.component.html",
  styleUrls: ["./department-person-form.component.scss"],
})
export class DepartmentPersonFormComponent {
  @Input() form: FormGroup;

  constructor(public fb: FormBuilder, public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/departments/department-person-form/department-person-form.component.ts